var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIndicator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 2,
    viewBox: "0 0 9 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.3,
    cy: 0.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 0.8,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.7,
    cy: 0.8,
    r: 0.8
  }))));
}
export default SvgDragIndicator;